import React from 'react';
import {Route, Routes} from 'react-router-dom';
import PersonalOfficeMain from '../PersonalOffice/Main/PersonalOfficeMain';
import MyTeam from '../PersonalOffice/MyTeam/MyTeam';
import Receipt from '../PersonalOffice/Receipt/Receipt';
import MyAccounts from '../PersonalOffice/PersonalAccount/MyAccounts';
import MyOrdersNewApi from '../PersonalOffice/MyOrders/MyOrdersNew';
import PopupRedactionOrder from '../PersonalOffice/MyOrders/MyOrdersPopups/PopupRedactionOrder';
import PersonalDynamic from '../PersonalOffice/PersonalDynamic/PersonalDynamic';
import Education from '../PersonalOffice/Education/Education';
import PersonalInfoUpdate from '../PersonalOffice/PersonalInfoUpdate/PersonalInfoUpdate';
import MediaAndNews from '../PersonalOffice/MediaAndNews/MediaAndNews';
import Marketing from '../PersonalOffice/Marketing/Marketing';
import Beginner from '../PersonalOffice/Education/Beginner';
import Transactions from '../PersonalOffice/Transactions/Transactions';
import RegistrationNewClient from '../PersonalOffice/RegistrationNewClient/RegistrationNewClient';
import ListOfProducts from '../PersonalOffice/ListOfProducts/ListOfProducts';
import PaperworkList from '../PersonalOffice/PaperworkList/PaperworkList';
import ListOfBonuses from '../PersonalOffice/ListOfBonuses/ListOfBonuses';
import CreateCashOrder from '../PersonalOffice/CashOrders/CreateCashOrder/CreateCashOrder';
import CashOrdersList from '../PersonalOffice/CashOrders/CashOrdersList/CashOrdersList';
import CustomerOrders from '../PersonalOffice/CastomerOrders/CustomerOrders';
import ProductReport from '../PersonalOffice/ProductReport/ProductReport';
import FinancialReport from '../PersonalOffice/FinancialReport/FinancialReport';
import ListOfInvoices from '../PersonalOffice/ListOfInvoices/ListOfInvoices';
import {NotFoundPage} from '../Components/NotFound';

const MainRoutes: React.FC = () => {
	return (
		<Routes>
			<Route path="/" element={<PersonalOfficeMain />} />
			<Route path={'my_team'} element={<MyTeam />} />
			<Route path={'my_bonus'} element={<Receipt />} />
			<Route path={'/my_accounts'} element={<MyAccounts />} />
			<Route path={'my_orders/*'} element={<MyOrdersNewApi />} />
			<Route path={'popup_reduction'} element={<PopupRedactionOrder />} />
			<Route path={'my_dynamic'} element={<PersonalDynamic />} />
			<Route path={'/education'} element={<Education />} />
			<Route
				path={'/personal_cabinet_update'}
				element={<PersonalInfoUpdate />}
			/>
			{/*<Route path={'/receipt'} element={<Receipt />} />*/}
			<Route path={'/news/*'} element={<MediaAndNews />} />
			<Route path={'/news/:newsId'} element={<Marketing />} />
			<Route path={'/education_module_1'} element={<Beginner />} />
			<Route path={'/transactions'} element={<Transactions />} />
			<Route
				path={'/registration_new_client'}
				element={<RegistrationNewClient type={'client'} />}
			/>
			<Route
				path={'/registration_new_manager'}
				element={<RegistrationNewClient type={'manager'} />}
			/>
			<Route path={'/list_of_products'} element={<ListOfProducts />} />
			<Route path={'/paperwork_list'} element={<PaperworkList />} />
			<Route path={'/list_of_bonuses'} element={<ListOfBonuses />} />
			<Route path={'/create_cash_order'} element={<CreateCashOrder />} />
			<Route path={'/cash_order_list'} element={<CashOrdersList />} />
			<Route path={'/customer_orders'} element={<CustomerOrders />} />
			<Route path={'/product_report'} element={<ProductReport />} />
			<Route path={'/financial_report'} element={<FinancialReport />} />
			<Route path={'/list_of_invoices/*'} element={<ListOfInvoices />} />
			<Route path="*" element={<NotFoundPage />} />
		</Routes>
	);
};

export default MainRoutes;
